import React, { useEffect, useState } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { GoogleOAuthProvider } from "@react-oauth/google";
import { ToastContainer } from 'react-toastify';

import { LandingScreen } from "./screens";
import { Navbar, Footer } from "./components";
import SplashScreen from "./components/splashScreen";
import Portfolios from "./screens/portfolio";
import ContactUs from "./screens/contactScreen/contactUs"
import AboutUs from "./screens/aboutScreen/aboutUs";
import JoinOurTeam from "./screens/JoinOurTeam";
import BlogScreen from "./screens/blog/blogScreen";
import ClientRequestForm from "./screens/requestScreen/clientRequestForm";

function App() {
  const [showSplash, setShowSplash] = useState(true);
  const [isSplashLeaving, setIsSplashLeaving] = useState(false);

  useEffect(() => {
    const minimumSplashTime = 300;
    const fadeDuration = 200;
    let isMounted = true;
    let hasMinimumTimeElapsed = false;
    let hasPageLoaded = document.readyState === "complete";
    let fadeTimeout;

    const finishSplash = () => {
      if (!isMounted || !hasMinimumTimeElapsed || !hasPageLoaded) {
        return;
      }

      setIsSplashLeaving(true);
      fadeTimeout = window.setTimeout(() => {
        if (isMounted) {
          setShowSplash(false);
        }
      }, fadeDuration);
    };

    const minimumTimer = window.setTimeout(() => {
      hasMinimumTimeElapsed = true;
      finishSplash();
    }, minimumSplashTime);

    const handlePageLoad = () => {
      hasPageLoaded = true;
      finishSplash();
    };

    if (hasPageLoaded) {
      finishSplash();
    } else {
      window.addEventListener("load", handlePageLoad);
    }

    return () => {
      isMounted = false;
      window.clearTimeout(minimumTimer);
      window.clearTimeout(fadeTimeout);
      window.removeEventListener("load", handlePageLoad);
    };
  }, []);
  
  return (
    <div className="min-h-screen bg-white font-rubik text-gray-900 transition-colors duration-300 dark:bg-dark-bg dark:text-dark-text">
      {showSplash && <SplashScreen isLeaving={isSplashLeaving} />}

      <GoogleOAuthProvider clientId={process.env.REACT_APP_GOOGLE_CLIENT_ID}>
        <BrowserRouter>
          <Navbar/>
          <Routes>
            <Route path="/" element={<LandingScreen/>}/>
            <Route path="/portfolio/*" element={<Portfolios/>}/>
            <Route path="/contact-us" element={<ContactUs/>}/>
            <Route path="/request-meeting" element={<ClientRequestForm/>}/>
            <Route path="/about" element={<AboutUs/>}/>
            <Route path="/blog" element={<BlogScreen/>}/>
            <Route path="/join" element={<JoinOurTeam/>}/>
          </Routes>
          <Footer/>
        </BrowserRouter>
      </GoogleOAuthProvider>

      <ToastContainer 
        position="top-right"
        autoClose={3000}
        closeOnClick={true}
        rtl={false}
        hideProgressBar
        draggable
        theme="light"
      />
    </div>
  );
}

export default App;
